import { useMutation } from '@tanstack/react-query';
import { useSharedMediaApi } from 'services';

export const useUploadTemporaryMediaItem = () => {
  const { uploadTemporaryMediaItem } = useSharedMediaApi();

  return useMutation({ mutationFn: uploadTemporaryMediaItem });
};
